import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  programUrl: PropTypes.string.isRequired,
  trainingName: PropTypes.string.isRequired,
};

export default function DownloadProgramNow({
  programUrl,
  trainingName,
}) {
  return (
    <div className="flex flex-col items-center text-center space-y-2 p-10 lg:py-20 space-y-8 max-w-screen-md mx-auto">
      <h4 className="text-xl lg:text-2xl font-semibold tracking-tight">
        {`Tu programa oficial del entrenamiento ${trainingName} está listo para ser descargado.`}
      </h4>
      <div className="text-center">
        <a className="inline-flex items-center space-x-2 bg-green-600 text-white px-8 py-4 leading-4  text-lg lg:text-xl rounded-full cursor-pointer hover:bg-green-500 focus:ring-2 focus:ring-green-600 focus:bg-green-600 focus:outline-none transition-all ease-in-out duration-300" href={programUrl}  download>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
          <div className="font-semibold">
            Descargar ahora
          </div>
        </a>
      </div>
    </div>
  );
}

DownloadProgramNow.defaultProps = defaultProps;
DownloadProgramNow.propTypes = propTypes;
